/**
 * Created by Kaku.Guo on 2018/10/26.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, AddToCartBtn } from '../index';
import AddReviewBtn from './AddReviewBtn';

const mapStateToProps = state => {
    const { accountInfo = {} } = state.get('user').toJS();
    return { accountId: accountInfo.id };
};

const AssetTileDetail = (props) => {
    const {
        data: {
            id,
            categories = [],
            owned,
            customAttributes,
            seller = {},
            reviewed
        },
        isLearnAsset,
        isCompact,
        accountId
    } = props;

    const sellerId = seller.owner;

    const getActionBtn = () => {
        if (customAttributes && customAttributes.BuyLink || reviewed) {
            return null;
        }
        if (owned) {
            if (accountId === sellerId) {
                return null;
            }
            return <AddReviewBtn data={{ id, sellerId }} />;
        }
        return <AddToCartBtn bindId={id} {...props} />;
    };

    return (
        <ul className="details">
            {!isCompact && !isLearnAsset && (
                <li className="categories">
                    <ul className="mock-text-ellipsis">
                        <div className="mock-ellipsis-container">
                            {categories && categories.map((cate) => {
                                if (cate.path !== 'assets') {
                                    return (
                                        <li
                                            key={`mock-ellipsis-item-cat-${cate.name}`}
                                            className="mock-ellipsis-item-helper">
                                            <Link
                                                className="mock-ellipsis-item-cat"
                                                to={`content-cat/${cate.path}`}
                                            >
                                                {cate.name}
                                            </Link>
                                        </li>
                                    );
                                }
                                return null;
                            })}
                        </div>
                    </ul>
                    <ul className="categories-full-view">
                        {categories && categories.map((cate2) => {
                            if (cate2.path !== 'assets') {
                                return (
                                    <li
                                        key={`mock-ellipsis-item-cat2-${cate2.name}`}>
                                        <Link
                                            className="mock-ellipsis-item-cat"
                                            to={`content-cat/${cate2.path}`}
                                        >
                                            {cate2.name}
                                        </Link>
                                    </li>
                                );
                            }
                            return null;
                        })}
                    </ul>
                </li>
            )}
            {getActionBtn()}
        </ul>
    );
};

AssetTileDetail.propTypes = {
    isLearnAsset: PropTypes.bool,
    isCompact: PropTypes.bool,
    data: PropTypes.object,
    accountId: PropTypes.string
};
export default connect(mapStateToProps, null)(AssetTileDetail);